export default {
  'workflowSettings.title': '审批流程',
  'workflowSettings.description':
    '按业务功能选择审批流程。流程节点和审批人在审批中心维护。',
  'workflowSettings.scope':
    '已接入业务：未绑定流程时直接办理，绑定后提交审批。待接入业务可先保存绑定，接入后生效。',
  'workflowSettings.connection': '业务接入',
  'workflowSettings.connected': '已接入',
  'workflowSettings.pendingConnection': '待接入',
  'workflowSettings.openCenter': '前往审批中心',
  'workflowSettings.refresh': '刷新流程',
  'workflowSettings.function': '业务功能',
  'workflowSettings.section': '业务环节',
  'workflowSettings.domain': '所属业务',
  'workflowSettings.investment': '投资项目',
  'workflowSettings.fund': '基金与募资',
  'workflowSettings.portfolio': '投后管理',
  'workflowSettings.exit': '退出管理',
  'workflowSettings.legacy': '历史业务',
  'workflowSettings.legacyHint':
    '这里保留旧业务已有的流程绑定，可更换或清除。当前业务请在对应分类中配置。',
  'workflowSettings.workflow': '审批流程',
  'workflowSettings.selectWorkflow': '选择已发布的审批流程',
  'workflowSettings.status': '绑定状态',
  'workflowSettings.bound': '已绑定',
  'workflowSettings.unbound': '未绑定',
  'workflowSettings.unsaved': '待保存',
  'workflowSettings.unavailable': '当前不可用',
  'workflowSettings.action': '操作',
  'workflowSettings.save': '保存',
  'workflowSettings.binding': '绑定',
  'workflowSettings.saved': '流程绑定已保存',
  'workflowSettings.saveFailed': '保存失败，请重试',
  'workflowSettings.search': '搜索业务功能，如立项',
  'workflowSettings.filterDomain': '筛选所属业务',
  'workflowSettings.allDomains': '全部业务',
  'workflowSettings.noWorkflow': '暂无可选择的审批流程',
  'workflowSettings.noWorkflowHint':
    '请前往审批中心创建并发布流程，然后刷新流程列表。',
  'workflowSettings.templateError':
    '审批流程加载失败，可重试刷新；已有绑定仍保留。',
  'workflowSettings.loadFailed': '绑定配置加载失败，请刷新重试',
  'workflowSettings.noFunction': '没有匹配的业务功能',
};
